export enum PaymentTypesEnum {
  free = 'dashboard.payment_type.free',
  one_shot = 'dashboard.payment_type.one_shot',
  subscription = 'dashboard.payment_type.subscription',
  installmanet_payment = 'dashboard.payment_type.installment_payment',
  limited_subscription = 'dashboard.payment_type.limited_subscription',
}
